import { isEmpty } from "lodash";

export default class {
  constructor(element, step) {
    this.element = element;
    this.step = step;
    this.$name = this.element.querySelector('.person-name');
    this.$name.addEventListener('change', () => this.updateStep());
    this.$name.addEventListener('keyup', () => this.$name.value.length > 2 && this.updateStep());
    this.updateStep();

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        console.log({ mutation })
        if (mutation.type === "childList" || mutation.type === "attributes") {
          this.updateStep();
        }
      }
    });
    observer.observe(this.element.querySelector('.student-form #enrollment_student_attributes_name'), { attributes: true, childList: true, subtree: true });
  }

  updateStep() {
    this.step.valid = this.isValid();
    this.updateSummary();
  }

  updateSummary() {
    if (!isEmpty(this.$name.value))
      return this.step.updateSummary(this.$name.value);

    this.step.updateSummary('<span class="font-red-flamingo"> <i class="fas fa-exclamation-circle mr-1"></i> Nome do aluno é obrigatório</span>');
  }

  isContactsValid() {
    return !isEmpty(this.$name.value) && [...this.element.querySelectorAll('.person-contact')].reduce((a, c) => {
      return a &= !isEmpty(c.querySelector('input.contact-number').value)
    }, true)
  }

  allFormGroupClear() {
    return this.element.querySelectorAll('.student-form .form-group.has-error').length == 0;
  }

  isValid() {
    return !isEmpty(this.$name.value) && this.isContactsValid() && this.allFormGroupClear();
  }
}